$(function() {

    // Check if logged in
    var login_token = Cookies.get('fotboll_login_token');
    $.post(
        ajaxUrl + "/ajax/getUser.php",
        {
            checklogin : 1,
        },
        function (data) {
            var result = $.parseJSON(data);
            if (result.success == true) {
                $('#mina-sidor-box').html('<div class="logged-in-initials">' + result.initials + '</div>');
            }
        }
    );


    $(document).on('submit', '#login', function(e){
        e.preventDefault();
        $("#error-wrong-password").hide();
        $("#error-not-found").hide();
        if($('#login-email').val() != '' && $('#login-password').val() != ''){
            var email = $('#login-email').val();
            var password = $('#login-password').val();
            $.post(
                ajaxUrl + "/ajax/login.php",
                {
                    email : email,
                    password : password
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success == true) {
                        Cookies.set('fotboll_com_identifier', result.user_id, { expires: 365, path: '/' });
                        window.location.href = '/mina-sidor';
                    } else {
                        if(result.msg == 'wrong-password'){
                            $("#error-wrong-password").fadeIn();
                        } else {
                            $("#error-not-found").fadeIn();
                        }
                    }
                }
            );
            return false;
        } else {
            return false;
        }
    });

    $(document).on('submit', '#forgot-password', function(e){
        e.preventDefault();
        if($('#forget-password-email').val() != ''){
            var email = $('#forget-password-email').val();
            $.post(
                ajaxUrl + "/ajax/forgotPassword.php",
                {
                    email : email
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success == true) {
                        window.location.href = window.location.href + "?pwforgot_success";
                    } else {
                        $("#error-not-found-pw").fadeIn();
                    }
                }
            );
            return false;
        } else {
            return false;
        }
    });

    $(document).on('click', '#forgot-password-link', function(){
        $('#forgot-password').fadeIn();
    });

    $(document).on('click', '#register-user-link', function(){
        $('#register-user').fadeIn();
    });

    $(document).on('click', '#change-password-link', function(){
        $('#change-password-form').fadeToggle();
    });

    $(document).on('click', '#change-alias-link', function(){
        $('#change-alias-form').fadeToggle();
    });

    $(document).on('click', '#delete-account-link', function(){
        $('#delete-account-form').fadeToggle();
    });


    $(document).on('submit', '#register-user', function(e){
        e.preventDefault();
        if($('#register-user-email').val() != ''){
            var email = $('#register-user-email').val();
            var offers = $('#accepts-offers').is(":checked");

            $.post(
                ajaxUrl + "/ajax/registerUser.php",
                {
                    email : email,
                    offers : offers
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success == true) {
                        window.location.href = window.location.href + "?register_success";
                    } else {
                        $('#error-already-registred').fadeIn();
                    }
                }
            );
            return false;
        } else {
            return false;
        }
    });

    $('#change-password, #change-password-verify').on('input', function() {
        $('#feedback, #matchFeedback').fadeIn();
        var password = $('#change-password').val();
        var confirmPassword = $('#change-password-verify').val();

        // Check password strength
        if (checkPasswordStrength(password)) {
            $('#feedback').text('Ditt lösenord är starkt.').removeClass('alert-danger').addClass('alert-success');
        } else {
            $('#feedback').text('Ditt lösenord måste vara minst 8 tecken långt och innehålla små och stora bokstäver, siffror samt specialtecken.')
                .removeClass('alert-success').addClass('alert-danger');
        }

        // Check if passwords match
        if (checkPasswordStrength(password) && confirmPassword !== '' && password === confirmPassword) {
            $('#matchFeedback').text('Lösenorden stämmer överens').removeClass('alert-danger').addClass('alert-success');
            $('#password-ok').val(1);
        } else {
            $('#matchFeedback').text('Lösenorden stämmer överens').removeClass('alert-success').addClass('alert-danger');
            $('#password-ok').val(0)
        }
    });

    $(document).on('submit', '#onboarding-form', function(e){
        e.preventDefault();

        if($('#change-password').val() != '' && $('#password-ok').val() == 1){
            var password = $('#change-password').val();
            var alias = $('#alias').val();
            //console.log(userToken);
            $.post(
                ajaxUrl + "/ajax/onboardUser.php",
                {
                    password : password,
                    alias : alias
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success == true) {
                        window.location.href = '/mina-sidor';
                    }
                }
            );
            return false;
        } else {
            return false;
        }
    });

    $(document).on('submit', '#change-password-form', function(e){
        e.preventDefault();

        if($('#change-password').val() != '' && $('#password-ok').val() == 1){
            var password = $('#change-password').val();
            $.post(
                ajaxUrl + "/ajax/changePassword.php",
                {
                    password : password
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success == true) {
                        // Display OK message
                        $("#change-password-form").fadeOut(function(){
                            $("#change-password-ok").fadeIn().delay(2000).fadeOut();
                        });
                    }
                }
            );
            return false;
        } else {
            return false;
        }
    });

    $(document).on('submit', '#change-alias-form', function(e){
        e.preventDefault();
        if($('#new-alias').val() != ''){
            var alias = $('#new-alias').val();
            $.post(
                ajaxUrl + "/ajax/changeAlias.php",
                {
                    alias : alias
                },
                function (data) {
                    var result = $.parseJSON(data);
                    if (result.success == true) {
                        // Display OK message
                        $("#change-alias-form").fadeOut(function(){
                            $("#my-pages-alias").html(alias);
                            $("#change-alias-ok").fadeIn().delay(2000).fadeOut();
                        });
                    }
                }
            );
            return false;
        } else {
            return false;
        }
    });

    $(document).on('submit', '#delete-account-form', function(e){
        e.preventDefault();
        $.post(
            ajaxUrl + "/ajax/deleteAccount.php",
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    Cookies.remove('favourite_teams');
                    Cookies.remove('favourite_leagues');
                    Cookies.remove('fotboll_com_identifier');
                    Cookies.remove('fotboll_login_token');
                    window.location.href = '/logga-in';
                }
            }
        );
        return false;

    });

});

function checkPasswordStrength(password) {
    var lengthCriteria = password.length >= 8;
    var uppercaseCriteria = /[A-Z]/.test(password);
    var lowercaseCriteria = /[a-z]/.test(password);
    var numberCriteria = /[0-9]/.test(password);
    var specialCharacterCriteria = /[!@#$%^&*()_\-+=<>?]/.test(password);

    return lengthCriteria && uppercaseCriteria && lowercaseCriteria && numberCriteria && specialCharacterCriteria;
}